'use strict';

/**
 * appends params to a url
 * @param {Object} $elementAppendTo - data returned from the server's ajax call
 * @param {string} msg - icon that was clicked to add a product to the wishlist
*/
function displayErrorMessage($elementAppendTo, msg) {
    if ($('.remove-from-wishlist-messages').length === 0) {
        $elementAppendTo.append(
            '<div class="remove-from-wishlist-messages "></div>'
        );
    }
    $('.remove-from-wishlist-messages')
        .append('<div class="remove-from-wishlist-alert text-center alert-danger">' + msg + '</div>');

    setTimeout(function () {
        $('.remove-from-wishlist-messages').remove();
    }, 3000);
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');
    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    }).done(function (data) {
        $('.wishlistItemCards').empty();
        $('body .wishlistItemCards').append(data);

        if (focusElementSelector) {
            $(focusElementSelector).focus();
        } else {
            document.documentElement.scrollTop = scrollPosition;
        }
    }).fail(function () {
        $('.more-wl-items').remove();
    });
    $.spinner().stop();
}

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function displayMessageAndChangeIcon(data, icon) {
    $.spinner().stop();
    /**
    var status;
    if (data.success) {
        status = 'alert-success';
        // if (icon.hasClass('fa-heart-o')) {
        //    icon.removeClass('fa-heart-o').addClass('fa-heart');
        // }
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
    }, 5000);
    */
}

/**
 * Add an item to a localStorage() array
 * @param {String} name  The localStorage() key
 * @param {String} value The localStorage() value
 */

function addToLocalWishlist(name, value) {
    var existing = localStorage.getItem(name);
    existing = existing ? existing.split(',') : [];
    existing.push(value);
    localStorage.setItem(name, existing.toString());
}

function removeFromLocalWishlist(name, value) {
    var existing = localStorage.getItem(name);
    existing = existing ? existing.split(',') : [];
    var eIndex = existing.indexOf(value);
    existing.splice(eIndex, 1);
    localStorage.setItem(name, existing.toString());
}

// 78210
// 86401
$(document).ready(function () {
    var userAuth = $('.search-results').data('iscustomerauthenticated');
    if (userAuth) {
        var datapiwl = $('.search-results').data('prodsinwishlist');
        if (datapiwl !== '') {
            datapiwl = datapiwl ? datapiwl.split(',') : [];
            localStorage.setItem('prodsinwishlist', datapiwl.toString());
            for (var i = 0; i < datapiwl.length; i++) {
                $('[data-pid=' + datapiwl[i] + '] .wishlistTile').removeClass("addToWishlist").addClass("removeFromWishlist wishlist-product-isadded");
            }
        } else {
            localStorage.removeItem('prodsinwishlist');
        }
    }
});


function loadauthAccountModel(name, value) {
    $('#authAccountModal').modal({
        backdrop: 'static',
        keyboard: false
    });
    $('#authAccountModal').attr("data-pid", value);
    $('#authAccountClose').attr("data-url", name);
    $('#authAccountClose').attr("data-test", "name");
}

// 45260

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.addToWishlist', function (e) {
            e.preventDefault();
            var icon = $(this).find($('i'));
            var url = $(this).attr('href');
            var dataurl = $(this).data('url');
            var pid = $(this).closest('.product').data('pid');
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            var wishListIcon = $(this);
            var userAuth = $(this).closest('.search-results').data('iscustomerauthenticated');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    if (!userAuth) {
                        loadauthAccountModel(dataurl, pid);
                    } else {
                        wishListIcon.removeClass("addToWishlist");
                        wishListIcon.addClass("removeFromWishlist wishlist-product-isadded");
                        addToLocalWishlist('prodsinwishlist', pid);
                    }
                    displayMessageAndChangeIcon(data, icon);
                },
                error: function (err) {
                    displayMessageAndChangeIcon(err, icon);
                }
            });
        });
    },
    removeFromWishlist: function () {
        $('body').on('click', '.removeFromWishlist', function (e) {
            e.preventDefault();
            var url = $(this).attr('data-url');
            var pid = $(this).closest('.product').attr('data-pid');
            var elMyAccount = $('.account-wishlist-item').length;
            // var wishListIcon = $(this);
            // If user is in my account page, call removeWishlistAccount() end point, re-render wishlist cards
            if (elMyAccount > 0) {
                $('.wishlist-account-card').spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'html',
                    data: {},
                    success: function (html) {
                        $('[data-pid=' + pid + ']').find('.wishlistTile').removeClass("removeFromWishlist").addClass("addToWishlist");
                        $('.wishlist-account-card>.card').remove();
                        $('.wishlist-account-card').append(html);
                        $('.wishlist-account-card').spinner().stop();
                        if (pid !== "") {
                            removeFromLocalWishlist('prodsinwishlist', pid);
                        }
                    },
                    error: function () {
                        var $elToAppend = $('.wishlist-account-card');
                        $elToAppend.spinner().stop();
                        var msg = $elToAppend.data('error-msg');
                        displayErrorMessage($elToAppend, msg);
                    }
                });
                // else user is in wishlist landing page, call removeProduct() end point, then remove this card
            } else {
                $.spinner().start();
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    data: {},
                    success: function () {
                        // wishListIcon.removeClass("removeFromWishlist");
                        // wishListIcon.addClass("addToWishlist");
                        $('[data-pid=' + pid + ']').find('.wishlistTile').removeClass("removeFromWishlist").addClass("addToWishlist");
                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                        if (pid !== "") {
                            removeFromLocalWishlist('prodsinwishlist', pid);
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                        var $elToAppendWL = $('.wishlistItemCards');
                        var msg = $elToAppendWL.data('error-msg');
                        displayErrorMessage($elToAppendWL, msg);
                    }
                });
            }
        });
    }
};
